import { useMutation, useQueryClient } from "@tanstack/react-query";
import { declineUserRequest } from "../services/decline-user-request";

export function useDeclineUserRequest() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (params: { id: string; reason: string }) =>
      declineUserRequest(params.id, params.reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-requests"] });
    },
  });
}
